import { useEffect, useState } from "react";
import { fetchCommuneData } from "../services/api";

const initialState = {
  communeData: null,
  communeDataLoading: false,
  communeDataError: null,
};

export const useCommuneData = (communeId) => {
  const [state, setState] = useState(initialState);

  useEffect(() => {
    if (!communeId) {
      setState({
        communeData: null,
        loading: false,
        error: "Error! Please provide communeId in the url.",
      });
      return;
    }

    setState({ data: null, loading: true, error: null });

    fetchCommuneData(communeId)
      .then((communeData) =>
        setState({
          communeData,
          loading: false,
          error: null,
        })
      )
      .catch((error) => {
        console.error(error);
        setState({
          communeData: null,
          loading: false,
          error: "Error fetching commune data 😔 Please refresh.",
        });
      });
  }, [communeId]);

  return state;
};
